<template>
  <span class="dr-biz-cart" @click="go">
    <el-badge :value="badge" :hidden="!showCount || !badge" :max="99">
      <i class="el-icon-shopping-cart-full dr-biz-cart__icon" :style="{ color: iconColor || undefined }"></i>
    </el-badge>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * 装修业务组件：购物车
 * 读 vuex cartCount getter；无 getter 则 badge=0
 */
export default {
  name: 'DrCartIcon',
  props: {
    link: { type: String, default: '/cart' },
    showCount: { type: Boolean, default: true },
    iconColor: { type: String, default: '' }
  },
  computed: {
    ...mapGetters({ cartCount: 'cartCount' }),
    badge() { return Number(this.cartCount) || 0 }
  },
  methods: {
    go() { this.$router.push(this.link || '/cart') }
  }
}
</script>

<style scoped>
.dr-biz-cart { display: inline-flex; cursor: pointer; padding: 4px; }
.dr-biz-cart__icon { font-size: 20px; color: var(--theme-text-primary, #303133); transition: color .15s; }
.dr-biz-cart:hover .dr-biz-cart__icon { color: var(--theme-primary, #4d6bfe); }
</style>
